<!-- RentWise Users -->
<div class="containerTest">

    <div class="text-center">
        <h1>Users enrolled under Agency: {{ auth.agencyInfo.agencyName }}</h1>
    </div>
    <hr>
    <div class="card">
        <div class="card-body" style="overflow-x:auto;">
            <div class="toolbar dt-buttons panel mb-4">
                <button type="button" class="dt-button" (click)="uploadUsers()">Upload Users</button>
                <button type="button" class="dt-button" (click)="inviteUsers()">Invite Users</button>
            </div>

            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="stripe hover row-border order-column">
                <thead>
                    <tr>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Progress</th>
                        <th>Completion Date</th>
                        <th>Completion In Person</th>
                        <th>Age Under 18</th>
                        <th>Date of Birth</th>
                        <th>Race</th>
                        <th>Ethnicity</th>
                        <th>Disabled?</th>
                        <th>Number of Children</th>
                        <th>Marital Status</th>
                        <th>Family Status</th>
                        <th>Education</th>
                        <th>Annual Income</th>
                        <th>Source of Income</th>
                        <th>Street Address</th>
                        <th>City</th>
                        <th>State</th>
                        <th>Zip Code</th>
                        <th>County</th>
                        <th>Primary Residence</th>
                        <th>Living Situation</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let user of users; index as i">
                        <td>{{ user.firstName }}</td>
                        <td>{{ user.lastName }}</td>
                        <td>{{ user.email }}</td>
                        <td>{{ user.phone }}</td>
                        <td>{{ (user.rentwiseProgress | percentage) || 'N/A' }}</td>
                        <td [attr.data-sort]="sortDate(user.rentwiseCompletionDate)">{{ (user.rentwiseCompletionDate | date) || 'N/A' }}</td>
                        <td>{{ user.rentwiseCompletionInPerson | boolean:'Yes':'No' }}</td>
                        <td>{{ user.ageUnder18 | boolean:'Yes':'No' }}</td>
                        <td [attr.data-sort]="sortDate(user.dob)">{{ user.dob | date }}</td>
                        <td>{{ user.race }}</td>
                        <td>{{ user.ethnicity }}</td>
                        <td>{{ user.disabled | boolean:'Yes':'No' }}</td>
                        <td>{{ user.numberOfChildren }}</td>
                        <td>{{ user.maritalStatus }}</td>
                        <td>{{ user.familyStatus }}</td>
                        <td>{{ user.education }}</td>
                        <td>{{ user.annualIncome }}</td>
                        <td>{{ user.sourceOfIncome }}</td>
                        <td>{{ user.streetAddress }}</td>
                        <td>{{ user.city }}</td>
                        <td>{{ user.state }}</td>
                        <td>{{ user.zipCode }}</td>
                        <td>{{ user.county }}</td>
                        <td>{{ user.primaryResidence | boolean:'Yes':'No' }}</td>
                        <td>{{ user.livingSituation }}</td>
                        <td>
                          <button *ngIf="user.rentwiseCompletionInPerson" (click)="deleteAgencyUser(i)" class="mr-2 btn-danger"><mdb-icon fas icon="trash"></mdb-icon></button>
                          <button *ngIf="user.rentwiseCompletionDate" (click)="viewUserCertificate(i)" class="text-nowrap">View Certificate</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
